<script setup lang="ts">
const props = defineProps<{
  category: CategoryBlock
}>()

const { styles } = useVariants('menuCategory')

const filter = useAllergenFilter()

const visibleItems = computed(() =>
  filter ? props.category.items.filter(filter.isItemVisible) : props.category.items,
)

const hasVisibleContent = computed(() => {
  if (!filter) return true
  if (visibleItems.value.length > 0) return true
  return props.category.subcategories.some(sub =>
    sub.items.some(filter.isItemVisible),
  )
})
</script>

<template>
  <div
    v-if="hasVisibleContent"
    :id="category.title.toLowerCase().replaceAll(' ', '-')"
    :class="styles.base()"
  >
    <div v-if="category.title || category.description">
      <h2 v-if="category.title" :class="styles.title()">
        {{ category.title }}
      </h2>
      <h3 v-if="category.description" :class="styles.description()">
        {{ category.description }}
      </h3>
    </div>
    <MenuItem v-for="item in visibleItems" :key="item.title" :item="item" />
    <MenuSubCategory
      v-for="sub in category.subcategories"
      :key="sub.title"
      :subcategory="sub"
    />
  </div>
</template>
